export default "__VITE_ASSET__C8jUfF8l__"